import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { kindergartenForm } from "../../../shared/formObjects/application/kindergartenForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function KindergartenComponent({ disabled, data, showEdit, showBack }: any) {
  const api = useApiClient("Kindergarten");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={kindergartenForm}
      headerLabel="Kindergarten Details"
      editPath="kindergarten"
      apiClient={api}
      disabled={disabled}
      data={data}
      showBack={showBack}
      showEdit={showEdit}
      id={id}
    />
  );
}

export default KindergartenComponent;
